module.exports = __webpack_public_path__ + "static/salonslider-01-min-18f7b110bcee7e1c0bdae0e349443a58.jpg";